import { Button } from '@ordr-as/umami-react'

interface Props {
    pageNumber: number
    onSwapPage: (pageNo: number) => void
}

const PaymentPaginationButtons = ({ pageNumber, onSwapPage }: Props) => {
    const hasNext = true
    const hasPrev = pageNumber > 0

    const startIndex = pageNumber * 25
    const endIndex = startIndex + 25

    return (
        <div className="py-5 flex flex-col items-center">
            <span className="text-xs xs:text-sm text-grey-dark">
                {`Showing ${startIndex} to ${endIndex - 1} of many entries`}
            </span>
            <div className="px-5 inline-flex mt-2 space-x-2">
                <Button kind="secondary" size="small" isDisabled={!hasPrev} onClick={() => onSwapPage(pageNumber - 1)}>
                    Prev
                </Button>
                <Button kind="secondary" size="small" isDisabled={!hasNext} onClick={() => onSwapPage(pageNumber + 1)}>
                    Next
                </Button>
            </div>
        </div>
    )
}

export default PaymentPaginationButtons
